<script setup>
import iconNote from '@client/svg/note.svg?raw';
const props = defineProps({ message: String });
</script>
<template>
    <Transition>
        <div v-show="props.message" class="fieldError" role="alert">
            <div v-html="iconNote"></div> {{ props.message }}
        </div>
    </Transition>
</template>
<style scoped lang="scss">
.fieldError {
    font-size: 0.75rem;
    color: #dc3545;
    line-height: 1.1;
    top: 100%;
    left: 0;
    width: 100%;
    height: auto;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    &:not(:empty) {
        margin-top: 4px;
        min-height: 1.067rem;
    }

    div {
        height: .875rem;
        width: .875rem;
        flex: 0 0 .875rem;
        align-self: flex-start;
        margin-top: 2px;
        margin-right: 4px;

        svg {
            width: 100%;
            height: auto;
            position: relative;
            vertical-align: middle;
        }
    }
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.1s ease, max-height 0.1s 0s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  max-height: 0;
  margin-top: 0;
}
</style>
